import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "count"]
    static values = {max: Number, showMax: {type: Boolean, default: true}}

    connect() {
        this.update()
    }

    update() {
        if (!this.hasInputTarget || !this.hasCountTarget) return

        const currentLength = this.inputTarget.value.length
        const maxLength = this.hasMaxValue ? this.maxValue : 280
        const showMax = this.hasShowMaxValue ? this.showMaxValue : true

        // Update text content: show "count/max" or just "count" based on showMax
        if (showMax) {
            this.countTarget.textContent = `${currentLength}/${maxLength}`
        } else {
            this.countTarget.textContent = currentLength
        }

        // Change color if over limit (red) or approaching limit (90% threshold for warning if showMax is true)
        if (currentLength > maxLength) {
            this.countTarget.classList.add("text-red-500")
            this.countTarget.classList.remove("text-gray-500", "dark:text-neutral-400", "text-gray-400")
        } else {
            if (showMax) {
                // For format "count/max", change color at 90%
                const percentage = (currentLength / maxLength) * 100
                if (percentage >= 90) {
                    this.countTarget.classList.add("text-red-500")
                    this.countTarget.classList.remove("text-gray-500", "dark:text-neutral-400", "text-gray-400")
                } else {
                    this.countTarget.classList.remove("text-red-500")
                    this.countTarget.classList.add("text-gray-500", "dark:text-neutral-400")
                }
            } else {
                // For format "count" only, keep default colors unless over limit
                this.countTarget.classList.remove("text-red-500")
                this.countTarget.classList.add("text-gray-500", "dark:text-neutral-400")
            }
        }
    }
}

